import { render, staticRenderFns } from "./FormWizardIcon.vue?vue&type=template&id=10394201&scoped=true&"
import script from "./FormWizardIcon.vue?vue&type=script&lang=js&"
export * from "./FormWizardIcon.vue?vue&type=script&lang=js&"
import style0 from "./FormWizardIcon.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./FormWizardIcon.vue?vue&type=style&index=1&id=10394201&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10394201",
  null
  
)

export default component.exports